/* Wise Angler terminal tackle PDP. Enhances the theme's own buy box (no cart logic replaced). Guard: window.WTT */
(function () {
  if (window.WTT) return;
  var d = document, W = window.WTT = {};
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function main() { var b = $('.wtt-buy'); return b && b.closest('.product-main'); }
  function tok(v) { return String(v || '').trim().split(/\s+/)[0]; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var fit = []; try { var j = $('script[data-wtt-json="fit"]'); if (j) fit = JSON.parse(j.textContent) || []; } catch (e) {}

  /* 1. size chips: split the theme's radio labels into size + detail */
  function chips() {
    var m = main(); if (!m) return;
    $$('variant-radios input[type=radio]+label', m).forEach(function (l) {
      if (l.querySelector('.wtt-chip-s')) return;
      var t = l.textContent.trim(), q = t.match(/QTY\s*(\d+)/i), kg = t.match(/(\d+)\s*kgs?/i);
      var meta = []; if (kg) meta.push(kg[1] + ' kg'); if (q) meta.push('QTY ' + q[1]);
      l.setAttribute('aria-label', t);
      l.innerHTML = '<span class="wtt-chip-s">' + esc(tok(t)) + '</span>' + (meta.length ? '<span class="wtt-chip-m">' + esc(meta.join(' · ')) + '</span>' : '');
    });
  }
  function radios() { var m = main(); return m ? $$('variant-radios input[type=radio]', m) : []; }
  function pickBy(fn) { var r = radios().filter(fn)[0]; if (r && !r.checked) { r.click(); } return r; }
  W.pickSize = function (s) { return pickBy(function (r) { return tok(r.value) === s; }); };
  W.pickId = function (id) { return pickBy(function (r) { return String(r.dataset.variantId) === String(id); }); };
  function current() { var r = radios().filter(function (x) { return x.checked; })[0]; return r ? r : null; }

  /* 2. which-size helper */
  function helper() {
    var box = $('[data-wtt-help]'); if (!box) return;
    var btn = $('[data-wtt-help-btn]', box), panel = $('[data-wtt-help-panel]', box), wrap = $('[data-wtt-help-chips]', box), out = $('[data-wtt-help-out]', box);
    if (!btn) return;
    var list = fit.filter(function (f) { return f.s || f.t; });
    if (!list.length) return;
    btn.hidden = false;
    wrap.innerHTML = list.map(function (f, i) { return '<button type="button" data-i="' + i + '" aria-pressed="false">' + esc(f.n) + (f.s ? '<b>' + esc(f.s) + '</b>' : '') + '</button>'; }).join('');
    btn.addEventListener('click', function () { var o = btn.getAttribute('aria-expanded') !== 'true'; btn.setAttribute('aria-expanded', o); panel.hidden = !o; });
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return; var f = list[+b.dataset.i];
      $$('button', wrap).forEach(function (x) { x.setAttribute('aria-pressed', x === b); });
      var msg = '';
      if (f.s) { var r = W.pickSize(f.s); msg = r ? f.n + ': ' + f.s + ' selected.' : f.n + ': we suggest ' + f.s + ', which is not in this range.'; }
      if (f.t) msg += (msg ? ' ' : f.n + ': ') + f.t + '.';
      if (f.h) msg += ' ' + f.h;
      out.textContent = msg;
    });
  }

  /* 3. size guide */
  function sizeGuide() {
    $$('[data-wtt-size-for]').forEach(function (el) {
      var names = fit.filter(function (f) { return f.s === el.dataset.wttSizeFor; }).map(function (f) { return f.n; });
      if (names.length) el.textContent = 'Best for: ' + names.join(', ');
    });
    d.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wtt-pick]'); if (!b) return;
      W.pickId(b.dataset.wttPick); var m = main();
      if (m) { var v = $('variant-radios', m) || m; v.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }); }
    });
  }
  function markSel() {
    var c = current(); var id = c && c.dataset.variantId;
    $$('.wtt-scale-i').forEach(function (li) { var b = $('[data-wtt-pick]', li); li.classList.toggle('is-sel', !!id && b.dataset.wttPick === id); });
  }

  /* 4. quick add (native form, AJAX when JS is on) */
  var toastT;
  function toast(html) { var t = $('[data-wtt-toast]'); if (!t) return; t.innerHTML = html; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(function () { t.hidden = true; }, 4200); }
  d.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-wtt-add]'); if (!f) return;
    e.preventDefault(); var b = $('button[type=submit]', f); var old = b.innerHTML; b.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); })
      .then(function (j) {
        b.classList.add('is-done'); b.textContent = 'Added';
        toast('Added ' + esc(j.product_title || '') + (j.variant_title ? ' (' + esc(j.variant_title) + ')' : '') + '<a href="/cart">View cart</a>');
        try { d.dispatchEvent(new CustomEvent('cart:update', { detail: {} })); } catch (x) {}
        setTimeout(function () { b.classList.remove('is-done'); b.innerHTML = old; b.disabled = false; }, 2200);
      })
      .catch(function (err) { toast(esc(err.message)); b.innerHTML = old; b.disabled = false; });
  });
  d.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-wtt-psel]'); if (!s) return;
    var o = s.options[s.selectedIndex], p = s.form && $('[data-wtt-pprice]', s.form); if (p && o) p.textContent = o.dataset.price;
  });

  /* 5. mobile sticky add to cart: drives the theme's own add button */
  function sticky() {
    var bar = $('[data-wtt-sticky]'), m = main(); if (!bar || !m) return;
    var add = $('button[name="add"]', m); if (!add) return;
    d.body.appendChild(bar); var t = $('[data-wtt-toast]'); if (t) d.body.appendChild(t); /* escape transformed theme sections so position:fixed is viewport-based */
    bar.hidden = false;
    var v = $('[data-wtt-sticky-v]', bar), sb = $('[data-wtt-sticky-add]', bar);
    var past = false, inFoot = false;
    function upd() {
      var c = current(), pr = $('.product-block__price .price-item--last', m) || $('.product-block__price .price-item', m);
      if (c && v) v.textContent = c.value + (pr ? ' · ' + pr.textContent.trim() : '');
      sb.disabled = !!add.disabled; sb.textContent = add.disabled ? 'Sold out' : 'Add to cart';
      bar.classList.toggle('is-on', past && !inFoot);
    }
    new IntersectionObserver(function (es) { es.forEach(function (x) { past = !x.isIntersecting && x.boundingClientRect.top < 0; }); upd(); }).observe(add);
    var end = $('.wtt-back'); if (end) new IntersectionObserver(function (es) { var x = es[0]; inFoot = x.isIntersecting || x.boundingClientRect.top < 0; upd(); }).observe(end);
    sb.addEventListener('click', function () { add.click(); });
    W.updSticky = upd; upd();
  }

  /* 6. restrained reveal */
  function reveal() {
    var els = $$('.wtt-rv'); if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function init() {
    chips(); helper(); sizeGuide(); markSel(); sticky(); reveal();
    var m = main();
    if (m) {
      var busy = false;
      new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { chips(); markSel(); if (W.updSticky) W.updSticky(); busy = false; }); }).observe(m, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
      m.addEventListener('change', function () { setTimeout(function () { markSel(); if (W.updSticky) W.updSticky(); }, 50); });
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
